/**
 * @param providers - In outer-to-inner order: the first entry is the outermost
 *   wrapper.
 * @returns A function that wraps its argument in every provider, in order.
 *   With zero providers it returns `children` unwrapped.
 */
export function composeProviders(...providers) {
    return (children) => providers.reduceRight((acc, wrap) => wrap(acc), children);
}
//# sourceMappingURL=composeProviders.js.map